/* «ΝΟΥΜΕΡΟ ΠΑΝΤΟΥ» (owner Σ07-13) — καθολικό size-popup, mono-parity design.
   PROGRESSIVE ENHANCEMENT + fail-open: κανένα Liquid δεν αλλάζει στους φορείς —
   το JS εντοπίζει κάθε «Νούμερο» και το ντύνει με trigger-πεδίο + popup:
   - variant fieldsets .pdp__swatch με legend που περιέχει «Νούμερο»
     → κρύβει pills, επιλογή = radio.click() (ΙΔΙΟ variant pipeline)
   - ιερά property selects (engraving-v2) name^="properties[Νούμερο"
     → κρύβει select/label, επιλογή = select.value + change/input
   Αν το JS δεν τρέξει → pills/selects δουλεύουν ως έχουν (τίποτα δεν χάνεται).
   Κανόνας προϊόντος: το πλέγμα = ΜΟΝΟ τα values του συγκεκριμένου φορέα
   (π.χ. PDPAOLA 50/52/54/56 — οι λίστες/κανόνες ζουν ΗΔΗ στο Liquid). */
(function () {
  'use strict';

  var modal = document.querySelector('[data-tj-szmodal]');
  if (!modal) return;
  var grid = modal.querySelector('[data-tj-szm-grid]');
  var sub = modal.querySelector('[data-tj-szm-sub]');
  var confirmBtn = modal.querySelector('[data-tj-szm-confirm]');
  var active = null;   // { read, apply, label, trigger }
  var tempValue = null;

  var RICO_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="14" r="6.5" stroke="currentColor" stroke-width="1.5"/><path d="M12 4l2.2 2.2L12 8.4 9.8 6.2 12 4z" stroke="currentColor" stroke-width="1.3"/><path d="M8.5 14h7M12 10.5v7" stroke="#c8c6a7" stroke-width="1"/></svg>';

  function displayVal(v) { return String(v).replace('.', ','); }

  function makeTrigger(label, optional) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tj-szfield';
    b.innerHTML =
      '<span class="tj-szf-ico">' + RICO_SVG + '</span>' +
      '<span class="tj-szf-lab"></span>' +
      '<span class="tj-szf-hint" data-tj-szf-hint>Πατήστε για επιλογή' + (optional ? ' (προαιρετικό)' : '') + '</span>' +
      '<span class="tj-szf-val" data-tj-szf-val hidden></span>' +
      '<span class="tj-szf-go">›</span>';
    b.querySelector('.tj-szf-lab').textContent = label;
    return b;
  }

  function refresh(entry) {
    var cur = entry.read().current;
    var val = entry.trigger.querySelector('[data-tj-szf-val]');
    var hint = entry.trigger.querySelector('[data-tj-szf-hint]');
    if (cur != null) {
      val.textContent = displayVal(cur);
      val.hidden = false;
      if (hint) hint.hidden = true;
    } else {
      val.hidden = true;
      if (hint) hint.hidden = false;
    }
  }

  function paint() {
    grid.querySelectorAll('button').forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-val') === tempValue);
    });
  }

  function open(entry) {
    var state = entry.read();
    if (!state.items.length) return;
    active = entry;
    tempValue = state.current;
    /* Σ07-14 #10: βέρες (mandatory) → σημείωση «κατασκευάζονται στο νούμερό σας»
       ΧΩΡΙΣ τη διέξοδο χωρίς-νούμερου· λοιπά προϊόντα → η standard με τη διέξοδο */
    var aStd = modal.querySelector('[data-tj-szm-assure-std]');
    var aMan = modal.querySelector('[data-tj-szm-assure-mandatory]');
    if (aStd) aStd.hidden = !!entry.mandatory;
    if (aMan) aMan.hidden = !entry.mandatory;
    if (sub) { sub.textContent = entry.label; sub.hidden = !entry.label; }
    grid.innerHTML = '';
    state.items.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-val', it.value);
      b.textContent = displayVal(it.value);
      b.addEventListener('click', function () { tempValue = it.value; paint(); });
      grid.appendChild(b);
    });
    paint();
    modal.showModal();
  }

  function applyAndClose() {
    if (active && tempValue != null) {
      active.apply(tempValue);
      refresh(active);
    }
    modal.close();
  }

  function register(entry) {
    entry.trigger.addEventListener('click', function () { open(entry); });
    refresh(entry);
  }

  /* ---- 1. Variant options «Νούμερο» (fieldset pills → popup) ---- */
  document.querySelectorAll('.pdp__swatch').forEach(function (fs) {
    var legend = fs.querySelector('.pdp__swatch-header');
    if (!legend || legend.textContent.indexOf('Νούμερο') === -1) return;
    var radios = fs.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    var label = legend.textContent.split(':')[0].trim();
    var entry = {
      label: label,
      read: function () {
        var items = [], current = null;
        fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
          items.push({ value: r.value });
          if (r.checked) current = r.value;
        });
        return { items: items, current: current };
      },
      apply: function (v) {
        fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
          if (r.value === v && !r.checked) r.click(); // ίδιο variant pipeline
        });
      }
    };
    var trigger = makeTrigger(label, false);
    entry.trigger = trigger;
    fs.classList.add('tj-sz-enhanced');
    fs.appendChild(trigger);
    fs.addEventListener('change', function () { refresh(entry); });
    register(entry);
  });

  /* ---- 2. Ιερά property selects (engraving-v2) — name^=properties[Νούμερο ---- */
  document.querySelectorAll('select.eng2__select').forEach(function (sel) {
    var name = sel.getAttribute('name') || '';
    if (name.indexOf('properties[Νούμερο') !== 0) return;

    var row = sel.closest('.eng2__duorow') || sel.parentElement;
    var lab = row.querySelector('label');
    var label = lab ? lab.textContent.trim() : 'Νούμερο';
    /* βέρες = υποχρεωτικό νούμερο (owner-matrix Σ07-14: κατασκευή ούτως ή άλλως) */
    var mandatory = name.indexOf('Νούμερο Γυναικείας') !== -1 || name.indexOf('Νούμερο Αντρικής') !== -1;
    var entry = {
      label: label,
      mandatory: mandatory,
      read: function () {
        var items = [], current = null;
        Array.prototype.forEach.call(sel.options, function (o) {
          if (o.disabled || o.value === 'none' || o.value === '') return;
          items.push({ value: o.value });
        });
        if (sel.value && sel.value !== 'none') current = sel.value;
        return { items: items, current: current };
      },
      apply: function (v) {
        if (sel.value === v) return;
        sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        sel.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };
    var trigger = makeTrigger(label, false);
    entry.trigger = trigger;
    row.classList.add('tj-sz-enhanced');
    row.appendChild(trigger);
    sel.addEventListener('change', function () { refresh(entry); });
    register(entry);
  });

  if (confirmBtn) confirmBtn.addEventListener('click', applyAndClose);
  modal.querySelectorAll('[data-tj-szm-close]').forEach(function (b) {
    b.addEventListener('click', function () { modal.close(); });
  });
  modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
})();
